module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Medium-e39d4081b339f42a2a55913a22dcfd15.woff";